import React from 'react'
import styles from '../EkgRecordingReviewScreen.css'
import SaveIcon from 'static/images/icons/content-save.svg'
import Loading from '../../../components/Loading'

const AddInterpretationControls = props => {
  const {
    saveDisabled,
    handleOnAddInterpretationsCancelClick,
    handleOnAddInterpretationsSaveClick,
    isSubmitting,
  } = props
  return (
    <div className={styles.addInterpretationControls}>
      <div className={styles.row}>
        <a
          onClick={handleOnAddInterpretationsCancelClick}
          className={styles.cancelButton}
        >
          Cancel
        </a>
        {isSubmitting ?
          <button
            className={styles.saveButtonLoading}
            disabled
          >
            <Loading />
          </button>
          :
          <button
            onClick={handleOnAddInterpretationsSaveClick}
            className={styles.saveButton}
            disabled={saveDisabled}
          >
            <SaveIcon />
            Save
          </button>
        }
      </div>
    </div>
  )
}

export default AddInterpretationControls



// WEBPACK FOOTER //
// ./src/legacy/containers/EkgRecordingReviewScreen/components/AddInterpretationControls.jsx